module.exports = __webpack_public_path__ + "img/CHEVRON_TOP.48b8852f.svg";